import React, { useEffect, useState } from "react";
import {
  Card, CardBody, CardHeader,
  Container, Table, Badge,
} from "reactstrap";
import { paymentsRepo } from "data/repositories/paymentsRepo";
import EmptyState from "components/EmptyState";
import { paymentStatusLabel } from "labels/tr";

export default function PaymentsPage() {
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    setPayments(paymentsRepo.list());
  }, []);

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h2 className="text-white mb-0">Ödemelerim</h2>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Card className="shadow">
          <CardHeader><h3 className="mb-0">Ödeme Geçmişi</h3></CardHeader>
          <CardBody>
            {payments.length === 0 ? (
              <EmptyState title="Henüz ödeme yok" />
            ) : (
              <Table className="align-items-center" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>Tarih</th>
                    <th>Açıklama</th>
                    <th>Tutar</th>
                    <th>Durum</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((p) => (
                    <tr key={p.id}>
                      <td>{p.createdAt ? new Date(p.createdAt).toLocaleDateString("tr-TR") : "-"}</td>
                      <td>{p.description || "-"}</td>
                      <td>{p.amount ? `₺${p.amount}` : "-"}</td>
                      <td>
                        <Badge color={p.status === "completed" ? "success" : "warning"}>
                          {paymentStatusLabel(p.status)}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
}
